'use strict';

/**
 * Client-side filter for the public member directory.
 *
 * The directory is fully server-rendered, so this only ever hides rows that are
 * already on the page — with JS disabled the complete list still renders. It
 * matches against name, institution, country, and bio, because "who works on
 * the thing I care about" is answered by the bio, and "who is at this lab" by
 * the institution heading; neither is reachable with the browser's own find.
 */

function initPeopleFilter() {
  const input = document.getElementById('people-filter-input');
  const list = document.getElementById('people-list');
  if (!input || !list) return;

  const status = document.getElementById('people-filter-status');
  const empty = document.getElementById('people-filter-empty');
  const groups = Array.from(list.querySelectorAll('.people_locus_group'));
  const total = parseInt(input.dataset.total, 10) || 0;

  // Build the searchable text once. Reading textContent per keystroke on a
  // large directory is the difference between instant and visibly laggy.
  const rows = groups.flatMap(group => {
    const institution = (group.dataset.institution || '').toLowerCase();
    return Array.from(group.querySelectorAll('.people_element')).map(el => {
      const bio = el.querySelector('.member-bio');
      return {
        el,
        group,
        haystack: [
          (el.dataset.name || '').toLowerCase(),
          institution,
          (bio ? bio.textContent : '').toLowerCase().trim(),
        ].join(' '),
      };
    });
  });

  function apply(query) {
    const q = query.trim().toLowerCase();
    let visible = 0;

    rows.forEach(row => {
      const match = q === '' || row.haystack.includes(q);
      row.el.hidden = !match;
      if (match) visible += 1;
    });

    // A group whose members are all filtered out should take its heading with
    // it, otherwise the page reads as a list of empty institutions.
    groups.forEach(group => {
      const anyVisible = group.querySelector('.people_element:not([hidden])') !== null;
      group.hidden = !anyVisible;
    });

    if (empty) empty.hidden = visible !== 0;

    if (status) {
      status.textContent = q === ''
        ? `Showing all ${total} members.`
        : `Showing ${visible} of ${total} members.`;
    }
  }

  input.addEventListener('input', () => apply(input.value));

  // Escape clears, matching the native behaviour of type="search".
  input.addEventListener('keydown', e => {
    if (e.key === 'Escape' && input.value !== '') {
      input.value = '';
      apply('');
    }
  });

  // A deep link from site search (#member-<id>) must win over a stale filter
  // value restored by the browser on back-navigation.
  if (window.location.hash.startsWith('#member-')) {
    input.value = '';
  }

  apply(input.value);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPeopleFilter);
} else {
  initPeopleFilter();
}
